/*=================================================
    summary: 筆記列表詳細資訊  (筆記列表 -> 筆記列表詳細資訊)

    remarks: 000 Tim 2021/11/19 Create
=================================================*/
import React, { useState, useEffect } from 'react'
import cssNoteDetail from './NoteDetail.module.scss'

import {AlertWindow, GlobalLibs, RoutePathLibs,PackageVariablesLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false

let mobjAuthorizedSubscription = null
// #endregion Member Variables

const COMP_NAME = "NoteDetail"

function NoteDetail(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State    
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    // #endregion Init State

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [props.BookSeqNo])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 Resource 頁面
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function BackOnTapHandler()
    {
        console.log(COMP_NAME + ".BackOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowNoteDetail"
        }
        props.CallbackRef(objCallbackData)
    } // end of BackOnTapHandler

    /*===========================================
    summary: 點選 前往 該 Lesson
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GoToLessonOnTapHandler(PropsBookSeqNo)
    {
        console.log(COMP_NAME + ".GoToLessonOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strBookSeqNo = PropsBookSeqNo.toString().PadLeft(2)

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(props.DetailData.LessonID))
        {
            blnExpired = false
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        }   

        if (!blnExpired)
        {
            console.log("GoToLessonOnTapHandler strBookSeqNo: ", strBookSeqNo)
            console.log("GoToLessonOnTapHandler DetailData.LessonID: ", props.DetailData.LessonID)
            console.log("GoToLessonOnTapHandler DetailData.LUSeqNo: ", props.DetailData.LUSeqNo)

            GotoLearningUnit(strBookSeqNo, props.DetailData.LessonID, props.DetailData.LUSeqNo);
        }
        else
        {
            console.log("GoToLessonOnTapHandler NoAuthorizedProcess");

            NoAuthorizedProcess(window.gSession.App.BookCatID, strBookSeqNo, props.DetailData.LessonID, props.DetailData.LUSeqNo)
        } // end of if (blnExpired)
    } // end of GoToLessonOnTapHandler
    // #endregion OnTapHandler

    // #region LoadingMask Functions
    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert
    // #endregion LoadingMask Functions

    // #region AlertCallBack
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            let objCallbackData = {
                "Action": "OpenSettings4NoAuthorized",
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack
    // #region AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: 取得 最後修改時間
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GetLastModifiedFormate(DateString) 
    {
        let datLastModified = new Date(DateString.replace(/-/g, '/'))
        let strLastModified = datLastModified.FormateBCDisplayDate().replace(/-/g, '/')

        return strLastModified
    } // end of GetLastModifiedFormate

    /*===========================================
    summary: 前往 Learning Unit 頁面
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function GotoLearningUnit (BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GotoLearningUnit: ", BookSeqNo, LessonID, LUCatSeqNo)
    
        let strLessonID = LessonID.PadLeft(5)
        let objLocationState = {
            "BookSeqNo": parseInt(BookSeqNo),
            "LessonID": strLessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo)
        }

        if (props.ButtonType !== window.gButtonTypeEnum.Lessons)
        {
            RoutePathLibs.Route2Path(props.History, "/Lessons", objLocationState)
        }
        else
        {
            let objCallbackData = {
                "Action": "GoToLearningUnit",
                "LocationState": objLocationState
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of GotoLearningUnit

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function NoAuthorizedProcess (BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": -1
        }
        
        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess
    // #endregion Other Functions

    // #region Render元件
    /*===========================================
    summary: Note Content 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentNoteContent( {NoteBody} )
    {   
        return(
            <div className={cssNoteDetail.divNoteContent}>
                <div className={cssNoteDetail.divNoteMsg}>
                    {NoteBody}
                </div> 
            </div>
        )
    } // end of ComponentNoteContent

    /*===========================================
    summary: Go To Lesson Button 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentGoToLessonButton( {PropsBookSeqNo} )
    {   
        return(
            <div className={cssNoteDetail.btnGoToLesson} onClick={() => GoToLessonOnTapHandler(PropsBookSeqNo)}>
                {window.gAppUI.BTN_GoToLesson}
            </div>
        )
    } // end of ComponentGoToLessonButton

    /*===========================================
    summary: 最後修改日期 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentLastModifiedDate( {LastModifiedTime} )
    {   
        let strDate = GetLastModifiedFormate(LastModifiedTime)
        return(
            <div className={cssNoteDetail.divLastModifiedDate}>
                {strDate}
            </div>
        )
    } // end of ComponentLastModifiedDate

    /*===========================================
    summary: Learning Unit Name 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentLearningUnitName( {LearningUnitName} )
    {   
        return(
            <div className={cssNoteDetail.divLearningUnitName}>
                {LearningUnitName}
            </div>
        )
    } // end of ComponentLearningUnitName

    /*===========================================
    summary: Lesson Name 顯示Component  
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function ComponentLessonName( {LessonPrefixText, LessonName} )
    {   
        let strLessonName = LessonPrefixText + "： " + LessonName
        return(
            <div className={cssNoteDetail.divLessonName}>
                {strLessonName}
            </div>
        )
    } // end of ComponentLessonName

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssNoteDetail.divTitle}>
                {window.gAppUI.LBL_Note}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Back Button 顯示Component  
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function ComponentBackButton()
    {   
        return(
            <div className={cssNoteDetail.btnBack} onClick={() => BackOnTapHandler()}/>
        )
    } // end of ComponentBackButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/19 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssNoteDetail.divContent}>
                <ComponentLessonName LessonPrefixText={props.DetailData.LessonPrefixText} LessonName={props.DetailData.LessonName} />
                <ComponentLearningUnitName LearningUnitName={props.DetailData.LUName} />
                <ComponentLastModifiedDate LastModifiedTime={props.DetailData.LastModifiedTime} />

                <ComponentGoToLessonButton PropsBookSeqNo={props.BookSeqNo} />
                
                <ComponentNoteContent NoteBody={props.DetailData.NoteBody} />
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 上方工具列 的顯示
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssNoteDetail.divTopTool}>
                <ComponentBackButton />
                <ComponentTitle />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/18 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssNoteDetail.divMain}>
                {RenderTopToolWrapper()}
                
                {RenderContentWrapper()}

                <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default NoteDetail